import { getAuthHeaders } from "../shared";
import { liftedVisitor } from "./lifted";

export type SubscriptionUpgradeType =
  | "Jammable Basic"
  | "Jammable Creator"
  | "Jammable Power User";

export async function mutationSubscriptionUpgrade(
  type: SubscriptionUpgradeType = "Jammable Creator",
  interval: "month" | "year" = "month",
  variant?: "last-chance",
  // Which screen asked, saved on the Stripe subscription (upgrade_source) so
  // an upgrade can be traced back to it.
  source?: string,
  // requiresAction: the bank wants 3D Secure before the charge (the yearly
  // switch only); confirm clientSecret with Stripe.js to finish.
): Promise<{ requiresAction?: boolean; clientSecret?: string }> {
  const response = await fetch(`/api/payment/subscription`, {
    method: "POST",
    headers: { ...(await getAuthHeaders()) },
    body: JSON.stringify({
      plan: type,
      interval,
      ...(variant ? { variant } : {}),
      ...(source ? { source } : {}),
    }),
  });

  if (response.status != 200) {
    throw new Error(`${response?.statusText}`);
  }

  const data = await response.json();
  return data;
}

export async function mutationCreateSubscriptionIntent({
  priceId,
  from,
  currency,
  couponId,
}: {
  priceId: string;
  currency?: string;
  from?: string;
  couponId?: string;
}): Promise<{
  clientSecret: string;
}> {
  const response = await fetch(`/api/payment/createSubscriptionIntent`, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      ...(await getAuthHeaders()),
    },
    body: JSON.stringify({
      priceId,
      currency,
      from,
      couponId,
      // Optional; see ./lifted.ts.
      liftedVisitor: liftedVisitor(),
    }),
  });

  if (response.status != 200) {
    throw new Error(`${response?.statusText}`);
  }

  const data = await response.json();
  return data;
}
